import { styled } from "@mui/material/styles";
import { Checkbox } from "Components/Form";
import { colors } from "@zapalacorp/tokens";

export const RequireEvidenceContainer = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  gap: "24px",
}));

export const CheckboxesEvidenceContainer = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  gap: "12px",

  "& label > span:first-of-type": {
    marginRight: "10px",
    marginLeft: "15px",
  },
}));

export const EvidenceText = styled("span")(() => ({
  color: colors.gray800,
  fontFamily: "Manrope",
  fontSize: "16px",
  lineHeight: "24px",
  letterSpacing: "0.5px",
}));

export const EvidenceCheckbox = styled(Checkbox)(() => ({
  color: colors.brandBlue600,
  fontFamily: "Manrope",
  fontSize: "16px",
  fontWeight: 600,
  lineHeight: "24px",
  letterSpacing: "0.15px",
}));

export const WrapperFooter = styled("div")(() => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  width: "100%",
}));
